var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group-item',_vm._b({on:{"click":function($event){return _vm.$emit('click', $event)}}},'b-list-group-item',Object.assign({}, _vm.$props, {variant: _vm.color}),false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }